n
<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-80">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<pwa-apcn-popup-search ref="pwaApcnSearch" :scrId="scrId"></pwa-apcn-popup-search>
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<pwa-apcn-popup-table
						ref="table"
						@PopupOpen="PopupOpen"
						@PopupRoOpen="PopupRoOpen"
						@pwaSelectedRow="pwaSelectedRow"
						:scrId="scrId"
					></pwa-apcn-popup-table>
				</sf-card>
			</div>
		</div>
	</div>
</template>

<script>
import PwaApcnPopupSearch from './Search/PwaApcnPopupSearch.vue'; //PWA신청현황
import PwaApcnPopupTable from './Table/PwaApcnPopupTable.vue'; //PWA 신청현황

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { PwaApcnPopupSearch, PwaApcnPopupTable },
	methods: {
		Refresh() {
			this.$refs.pwaApcnSearch.searchList();
		},
		PopupOpen(param) {
			//console.log('ContentView 에서의 param값 ::::: ', param);

			this.$refs.pwaApcnPopup.open(param);
		},
		PopupRoOpen(param) {
			this.$refs.roApcnPopup.open(param);
		},
		pwaSelectedRow(row) {
			this.$emit('pwaSelectedRow', row);
		},
		PwaApcnListSearch() {
			this.$refs.pwaApcnSearch.searchList();
		}
	}
};
</script>

<style></style>
